import { render, staticRenderFns } from "./TypeStageEdit.vue?vue&type=template&id=3bbc9b72&"
import script from "./TypeStageEdit.vue?vue&type=script&lang=js&"
export * from "./TypeStageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports